import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl } from "../lib/api";
import { Search } from "lucide-react";

const Card = ({ u }) => (
    <Link to={`/profile/${u.id}`} className="bg-paper rounded-2xl border border-border-line soft-shadow-sm p-5 hover:-translate-y-1 transition-transform duration-300 block" data-testid={`explore-card-${u.id}`}>
        <div className="flex gap-3">
            <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-gold bg-surface flex items-center justify-center shrink-0">
                {u.profile?.avatar_url ? <img src={mediaUrl(u.profile.avatar_url)} alt="" className="w-full h-full object-cover" /> : <span className="font-heading text-xl text-ink">{u.full_name?.[0]?.toUpperCase()}</span>}
            </div>
            <div className="min-w-0">
                <div className="font-medium truncate">{u.full_name}</div>
                <div className="text-xs text-muted truncate">{u.profile?.headline}</div>
                <div className="text-xs text-muted mt-1">{u.profile?.industry} · {u.profile?.location}</div>
            </div>
        </div>
        {u.profile?.skills?.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-4">
                {u.profile.skills.slice(0, 3).map((s) => <span key={s} className="text-[10px] px-2 py-0.5 rounded-full bg-surface border border-border-line">{s}</span>)}
            </div>
        )}
    </Link>
);

const Explore = () => {
    const [users, setUsers] = useState([]);
    const [q, setQ] = useState("");
    const [industry, setIndustry] = useState("");
    const [location, setLocation] = useState("");
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const params = q || industry || location ? new URLSearchParams({ q, industry, location }).toString() : "";
            const url = params ? `/search?${params}` : "/explore";
            const { data } = await api.get(url);
            setUsers(data);
        } finally { setLoading(false); }
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

    return (
        <div data-testid="explore-page">
            <h1 className="font-heading text-4xl">Esplora la rete</h1>
            <p className="text-sm text-muted mt-1 mb-6">Scopri professionisti, settori, e nuove connessioni.</p>
            <div className="bg-paper rounded-2xl border border-border-line p-4 mb-6 grid sm:grid-cols-3 gap-3">
                <div className="relative">
                    <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted pointer-events-none z-10" />
                    <input data-testid="search-q" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Nome, competenza…" className="input-clean" style={{ paddingLeft: '2.5rem' }} />
                </div>
                <input data-testid="search-industry" value={industry} onChange={(e) => setIndustry(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Settore" className="input-clean" />
                <input data-testid="search-location" value={location} onChange={(e) => setLocation(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Località" className="input-clean" />
            </div>
            <button data-testid="search-btn" onClick={load} className="btn-primary text-sm mb-6">Cerca</button>
            {loading ? <div className="text-center text-muted py-10">Caricamento…</div> : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {users.length === 0 && <div className="col-span-full text-center text-muted py-12">Nessun risultato</div>}
                    {users.map((u) => <Card key={u.id} u={u} />)}
                </div>
            )}
        </div>
    );
};

export default Explore;
